import React from "react";

const BG = { arena: "/hero-arena.webp", walkout: "/event-walkout.webp" };

export function PageHero({ eyebrow, title, children, image = "arena", position = "center", testId }) {
  return (
    <section className="relative overflow-hidden border-b border-[#151515] bg-black grain min-h-[52vh] flex items-end" data-testid={testId}>
      <img src={BG[image]} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" style={{ objectPosition: position }} />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
      <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 pt-28 pb-14 lg:pb-20 w-full">
        {eyebrow && <div className="type-label text-[#C8102E] mb-4 reveal-up">{eyebrow}</div>}
        <h1 className="type-page-title reveal-up delay-1">{title}</h1>
        {children && <div className="mt-6 text-[#d0d0d0] text-lg max-w-[560px] reveal-up delay-2">{children}</div>}
      </div>
    </section>
  );
}
